/**
 *
 * WIP: temporary solution till `Max withdrawable/receivable amount` APIs are implemented
 * @see https://www.notion.so/tradeparadigm/Max-withdrawable-receivable-amount-42daf33ab5894005bbd2dfa3b93f063f
 *
 */
import BigNumber from 'bignumber.js';

import { useAccountState } from '#/features/account/account-context';
import { useBalancesStore } from '#/features/balance/balance-context';

import SETTINGS from '#/config/global-settings';

export function useMaxWithdrawableAmount(): BigNumber | null {
  const accountState = useAccountState();
  const balancesStore = useBalancesStore();

  const freeCollateral = accountState.account?.free_collateral;
  const usdcBalance = balancesStore.getBalance('USDC');

  if (usdcBalance == null) return null;
  if (freeCollateral == null) return null;

  const min = BigNumber.min(freeCollateral, usdcBalance.size);
  const minRounded = min.decimalPlaces(
    SETTINGS.fiat.USD.scale,
    BigNumber.ROUND_DOWN,
  );

  return minRounded;
}
